import { render, staticRenderFns } from "./messageFrom.vue?vue&type=template&id=0be59ce0&scoped=true"
import script from "./messageFrom.vue?vue&type=script&lang=js"
export * from "./messageFrom.vue?vue&type=script&lang=js"
import style0 from "./messageFrom.vue?vue&type=style&index=0&id=0be59ce0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be59ce0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be59ce0')) {
      api.createRecord('0be59ce0', component.options)
    } else {
      api.reload('0be59ce0', component.options)
    }
    module.hot.accept("./messageFrom.vue?vue&type=template&id=0be59ce0&scoped=true", function () {
      api.rerender('0be59ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/examine/components/messageFrom.vue"
export default component.exports